import React from 'react';
import ObiLoading from '../common/ObiLoading';
// import NotificationListing from '../common/NotificationListing';

import { ListItemText,
  ListItemIcon,
  ListItem,
  List,
  Collapse,
  Button,
  Hidden,
  Drawer,
  Divider,
  AppBar,
  Toolbar,
  Grid,
  Box,
  Icon,
  IconButton,
  Typography,
  Tooltip } from '@mui/material';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HelpIcon from '@mui/icons-material/Help';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ListIcon from '@mui/icons-material/List';
import UpdateIcon from '@mui/icons-material/Update';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsIcon from '@mui/icons-material/Notifications';

import { makeStyles, useTheme } from '@mui/styles';

import { HSAMoneyFormat } from '../../utility/common/GlobalHSA';

import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';

import ObiLogo from '../common/obigraphics/ObiLogo';

import EnvBanner from '../common/EnvBanner';

import Brightness5Icon from '@mui/icons-material/Brightness5';
import Brightness3Icon from '@mui/icons-material/Brightness3';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import {
  logout,
  generalSwitchTheme
} from '../../actions';

const { REACT_APP_VERSION } = process.env;

// "personalNotifications": {
//   name: 'Notifications',
//   icon: NotificationsIcon,
//   url: '/partner/notifications',
// },

const agentNav = {
  "dashboard": {
        name: 'Dashboard',
        icon: DashboardIcon,
        url: '/partner/',
  },
  "personalInformation": {
    name: 'Personal Information',
    icon: AccountCircleIcon,
    url: '/partner/personal',
  },
  "bankingInformation": {
    name: 'Banking Information',
    icon: AccountBalanceIcon,
    url: '/partner/banking',
  },
  "clientList": {
    name: 'Client List',
    icon: ListIcon,
    url: '/partner/client-list',
  },
  "commissions": {
    name: 'Commissions',
    icon: AttachMoneyIcon,
    url: '/partner/commissions',
  },
  // "hsaSales": {
  //   name: 'HSA Sales',
  //   icon: AssessmentIcon,
  //   url: '/partner/hsa-sales',
  // },
  "upcomingRenewals": {
    name: 'Upcoming Renewals',
    icon: UpdateIcon,
    url: '/partner/upcoming-renewals',
  }
}

const adminNav = {
  "agentList": {
    name: 'Agent List',
    icon: AssessmentIcon,
    url: '/partner/agent-list',
  },
}

const generalNav = {
  "documents": {
    name:'Documents',
    icon: DescriptionIcon,
    url: '/partner/documents',
    external: false,
    innerList: {}
  },
  "privacy": {
    name: "Privacy Policy",
    icon: DescriptionIcon,
    url: "https://www.olympiafinancial.com/privacy-policy",
    external: true,
    innerList: {}
  },
  // "faqs": {
  //   name: "FAQs",
  //   icon: HelpIcon,
  //   url: "/partner/faqs",
  //   external: false,
  //   innerList: {}
  // },
  // "resources": {
  //   name: "Resource Library",
  //   icon: MenuBookIcon,
  //   url: "https://www.olympiabenefits.com/knowledge-base",
  //   external: true,
  //   innerList: {}
  // }
};

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
  },
  footer: {
    height: '100px'
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    zIndex: 5,

  },
  appBar: {
    zIndex: theme.zIndex.drawer - 1,
    backgroundColor: theme.palette.appBar.main,
    color: theme.palette.appBar.contrastText,
    [theme.breakpoints.up('md')]: {
      paddingLeft: `${drawerWidth}px`
    },
  },
  appProfile:{
    textDecoration: 'none',
    textTransform: 'capitalize',
    userSelect: 'none',
    color: theme.palette.primary.main,
  },
  appTitle:{
    color: theme.palette.appBar.contrastText,
    [theme.breakpoints.up('md')]: {
      paddingLeft: `15px`
    },
  },
  appLogo:{
    textDecoration: 'none',
    padding: theme.spacing(1),
    width: '100px'
  },
  appVersion:{
    padding: theme.spacing(2),
    color: theme.palette.common.white,
    textAlign:'right'
  },
  menuButton: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.drawer.main,
    color: theme.palette.drawer.contrastText
  },
  drawerId:{
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    borderRadius: '5px',
    backgroundColor: theme.palette.drawerId.main,
    color: theme.palette.drawerId.contrastText
  },
  drawerNav:{
    paddingLeft: theme.spacing(2),
    color: theme.palette.drawerNav.contrastText,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.hover,
    }
  },
  drawerNavIcon:{
    color: theme.palette.drawerNav.contrastText
  },
  nested: {
    paddingLeft: theme.spacing(4),
    color: theme.palette.drawerNav.contrastText,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.main,
    }
  },
  disablednested:{
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.ltgrey.main,
    '&:hover': {
      backgroundColor: theme.palette.ltgrey.main,
    }
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth
    },
  },
}));

function updateTheme(props){
  props.generalSwitchTheme();
}

function renderNavElement(navElement, props, classEle, classIcon, endIcon){
  if(navElement.willRender && !navElement.willRender(props)){
    return false;
  }

  let disabled = false;
  if(navElement.isDisabled){
    if(typeof navElement.isDisabled == 'function'){
      disabled = navElement.isDisabled(props);
    }else{
      disabled = (navElement.isDisabled);
    }
  }

  return <ListItem key={navElement.name} 
    className={classEle}
    button
    {...(navElement.external && navElement.url)? {href: navElement.url, component: Button, target: '_blank', rel: "noreferrer"}: {}}
    {...(!navElement.external && navElement.url)? {to: navElement.url, component: Link}: {}}  
    {...(disabled)? {disabled: disabled}: {}}
    {...(navElement.onClick)? {onClick: navElement.onClick}: {}}
     >
    <ListItemIcon><Icon className={classIcon} component={navElement.icon} /></ListItemIcon>
    <ListItemText primary={navElement.name} />
    {endIcon}
  </ListItem>
}

function renderList(navElement, props, classes, handleMenuExpand, expanded, renderFlat=false){
  if(!navElement){
    return false;
  }
  if(!navElement.innerList || Object.values(navElement.innerList).length < 1){
    return renderNavElement(navElement, props, classes.drawerNav, classes.drawerNavIcon);
  }
  if(renderFlat){
    return Object.values(navElement.innerList).map((innerNavElement) => {
        return renderNavElement(innerNavElement, props, classes.drawerNav, classes.drawerNavIcon);
      });
  }
  return (
    <div>
      <ListItem key={navElement.name} className={classes.drawerNav} button onClick={() => handleMenuExpand(navElement.name)}>
        <ListItemIcon><Icon className={classes.drawerNavIcon} component={navElement.icon} /></ListItemIcon>
        <ListItemText primary={navElement.name} />
        {expanded[navElement.name] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={expanded[navElement.name]} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {Object.values(navElement.innerList).map((innerNavElement) => {
            return renderNavElement(innerNavElement, props, classes.nested, classes.drawerNavIcon);
          })}
        </List>
      </Collapse>
    </div>
  );
}

function WrapperMain(props) {

  const { window } = props;
  const { usePrint, printPreview } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [notificationsOpen, setNotificaionsOpen] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const isAdmin = (props.user.MANAGER === props.user.ID)? 'Y' : 'N';

  if(usePrint && printPreview){
    return printPreview;
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuExpand = (id) => {
    setExpanded((prevState => ({...prevState, [id]: !prevState[id]})));
  }

  const drawer = (
    <div>
      <Grid container justifyContent="flex-start" alignItems="center" >
        <Grid item xs={12}>
          <Box p={2}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={6}>
                <ObiLogo width="100%" fill="#fff"/>
              </Grid>
            </Grid>
            <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
              <PersonIcon />
               <Typography>
                <Typography align="right">Agent ID</Typography>
                <Typography align="right"># {props.user.ID}</Typography>
               </Typography>
            </Grid>
            <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
              <AccountBalanceIcon />
              <Typography>
                <Typography align="right">Accrued Commissions</Typography>
                <Typography align="right">{HSAMoneyFormat(props.user.UNPAID_COMMISSION)}</Typography>
              </Typography>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <List>
        {Object.values(agentNav).map( (navElement) => {
          return renderList(navElement, props, classes, handleMenuExpand, expanded, false);
        })}
      </List>
      <Divider />
      {(isAdmin === 'Y') && 
      <List>
        {Object.values(adminNav).map( (navElement) => {
          return renderList(navElement, props, classes, handleMenuExpand, expanded, false);
        })}
      </List>}
      <Divider />
      <List>
        {Object.values(generalNav).map( (navElement) => {
          return renderList(navElement, props, classes, handleMenuExpand, expanded, false);
        })}
        <ListItem className={classes.drawerNav} button onClick={ () => props.logout(props.user.TYPE) }>
          <ListItemIcon><ExitToAppIcon className={classes.drawerNavIcon} /></ListItemIcon>
          <ListItemText primary={'Logout'} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem key={'Theme'} className={classes.drawerNav} button onClick={()=>updateTheme(props)} >
          <ListItemIcon><Icon className={classes.drawerNavIcon} component={(props.chosenTheme == 'dark')? Brightness5Icon: Brightness3Icon} /></ListItemIcon>
          <ListItemText primary={(props.chosenTheme == 'dark')? 'Enable Light Mode': 'Enable Dark Mode'} />
        </ListItem>
      </List>
      <Typography className={classes.appVersion} variant="caption" display="block" align="right">app v{REACT_APP_VERSION}<br/>Copyright © {new Date().getFullYear()} Olympia Benefits Inc.<br/>All Rights Reserved</Typography>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <AppBar position="sticky" className={classes.appBar}>
        <EnvBanner />
        <Toolbar>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs>
            <Hidden mdUp>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
            </Hidden>
            <Hidden mdDown>
              <Grid item xs zeroMinWidth>
                <Typography className={classes.appTitle} noWrap>{props.title}</Typography>
              </Grid>
            </Hidden>
          </Grid>

          <Hidden mdUp>
            <Grid item className={classes.appLogo} component={Link} to="/">
              <Grid container direction='row' justifyContent="center" alignItems="center">
                <Grid item >
                  <ObiLogo height={50} fill={theme.palette.primary.main}/>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>

          <Grid item xs>
            <Grid container direction='row' justifyContent="flex-end" alignItems="center">
              <Grid item>
                <Hidden lgUp>
                  <Tooltip title="Personal Details" arrow aria-label="Personal Details">
                    <IconButton
                      component={Link} 
                      to="/partner/personal">
                      <PersonIcon />
                    </IconButton>
                    </Tooltip>  
                </Hidden>
                <Hidden lgDown>
                  <Tooltip title="Personal Details" arrow aria-label="Personal Details">
                    <Button className={classes.appProfile} component={Link} to="/partner/personal">
                      <PersonIcon />
                      <Typography>{(props.user.AGENT_NAME)? props.user.AGENT_NAME : props.user.MANAGER_NAME } #{props.user.ID}</Typography>
                    </Button>
                  </Tooltip>
                </Hidden>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden lgUp implementation="js">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden mdDown implementation="js">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        {(props.inSuspense)? <ObiLoading /> : props.children}
        <div className={classes.footer} />
      </main>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    error: state.auth.error,
    errors: state.auth.errors,
    loading: state.auth.loading,
    chosenTheme: state.general.chosenTheme
  };
};

export default connect(mapStateToProps, {
  logout,
  generalSwitchTheme
})(withRouter(WrapperMain));
